'use strict';

//Includes

import { AppContext } from 'plugin/liferay-widgets-react-web';
import { ClassNames as BaseClassNames } from 'plugin/base-portlet';
import { ClassNames, FormIds } from './constants/Constants';
import { default as StateValueChangeRecordRenderer } from './components/StateValueChangeRecordRenderer';
import { default as StateValueDetailsListRenderer } from './components/StateValueDetailsListRenderer';
//Store-Factory
import { getStateStore } from './stores/StoreFactory';
// WebApi
import { default as StateWebApi } from './webapi/StateWebApi';
import { default as StateValueWebApi } from './webapi/StateValueWebApi';
// Actions
import { default as StateActions } from './actions/StateActions';
import { default as StateValueActions } from './actions/StateValueActions';

export { ClassNames, FormIds };

export * from './stores/StoreFactory';

export { StateWebApi };

export { StateValueWebApi };

AppContext.registerBundle({
    webApis: {
        StateWebApi,
        StateValueWebApi
    }
});

/*
 * Export bundled Modules i.e. require(ChangeRecordRenderer/StateValue, renderer=> {...}).
 * See package.json and build.json
 */
export const State = undefined;
export const StateValue = undefined;
export const ChangeRecordRenderer_StateValue = StateValueChangeRecordRenderer;  //ChangeRecordRenderer/StateValue
export const DetailsRenderer_StateValue = StateValueDetailsListRenderer;   //DetailsRenderer/StateValue

export { StateActions };

export { StateValueActions };

console.warn('TODO cleanup StateActions.attachedList');
StateActions.load(); //early states
StateActions.attachedList('GroupStates', AppContext.getScopeGroupId(), BaseClassNames.Group, {}); //early states

//const StateValueStore = getStateValueStore(AppContext);
const StateStore = getStateStore(AppContext);
if (!StateStore.getStates()) console.warn('GroupStates not initialized');

export { default as MiniWidgetStatusLine } from './components/MiniWidgetStatusLine';
export { default as StateEditForm } from './components/StateEditForm';
export { default as StateSelect } from './components/StateSelect';
export { default as StateValueEditForm } from './components/StateValueEditForm';
export { default as StateValueListItem } from './components/StateValueListItem';
export { default as DetailsBoxStatus, StatusLine } from './components/DetailsBoxStatus';
export { default as StateValueList } from './components/StateValueList';
export { default as StateValueLabel } from './components/StateValueLabel';
export { default as StateDetailsList } from './components/StateDetailsList';
export { default as FliwasStatusIcon } from './components/FliwasStatusIcon';
export { default as FliwasListItemStatus } from './components/FliwasListItemStatus';



// WEBPACK FOOTER //
// ./js/state-portlet.js